module.exports = __webpack_public_path__ + "img/ic_flag_germany.91dfd06b.svg";